import { render, staticRenderFns } from "./NewUploadFile.vue?vue&type=template&id=45f30d80&scoped=true"
import script from "./NewUploadFile.vue?vue&type=script&lang=js"
export * from "./NewUploadFile.vue?vue&type=script&lang=js"
import style0 from "./NewUploadFile.vue?vue&type=style&index=0&id=45f30d80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f30d80",
  null
  
)

export default component.exports